/** @jsxImportSource @emotion/react */
import React from 'react';
import { css } from '@emotion/react';
import UserGroup from '@/assets/svgs/user-group.svg?react';
import HomeSetting from '@/assets/svgs/home-setting.svg?react';
import PermissionSetting from '@/assets/svgs/permission-setting.svg?react';
import ArrowLeft from '@/assets/svgs/arrow-left.svg?react';
import Health from '@/assets/svgs/health.svg?react';
import Setting from '@/assets/svgs/setting.svg?react';
import ChatGPT from '@/assets/svgs/chat-gpt.svg?react';
import Wellness from '@/assets/svgs/wellness.svg?react';
import Notification from '@/assets/svgs/notification.svg?react';

type IconProps = {
  width: number | string;
  height: number | string;
  fill?: string;
  type: string;
};

const iconMap: Record<string, React.ComponentType<any>> = {
  userGroup: UserGroup,
  homeSetting: HomeSetting,
  setting: Setting,
  permissionSetting: PermissionSetting,
  arrowLeft: ArrowLeft,
  health: Health,
  chatGPT: ChatGPT,
  wellness: Wellness,
  notification: Notification
};

export const Icon = ({ type, width, height, fill = '#858585' }: IconProps) => {
  const SelectedIcon = iconMap[type];

  if (!SelectedIcon) return null;
  return <SelectedIcon width={width} height={height} css={iconStyles(fill)} />;
};

const iconStyles = (fill: string) => css`
  path {
    fill: ${fill};
  }
`;
